/* eslint-disable newline-after-var */
// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ActionsPopover from '../../../../shared/components/actions-popover';
import Claim from '@deere/cps-it.warranty-model-factory/lib/claim';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildAuditDealerString} from '../../../shared/services/build-audit-dealer-string.js';
import {getPrintAuditOptions} from '../../../shared/services/get-print-audit-options';

function handleSubmit() {

    this.actions.updateRecordAuditModalVisibility(true);

}

function handlePrintClaimsButtonClick() {

    this.actions.readAuditCreditMemoClaims(this.claims, this.user.getLocale());

}

function handlePrintCreditMemoButtonClick() {

    this.actions.readAuditCreditMemos(this.claims, this.user.getLocale());

}

const RecordAuditHeader = props => {

    const options = getPrintAuditOptions(props::handlePrintClaimsButtonClick, props::handlePrintCreditMemoButtonClick);

    return (
        <div>
            <div className='record-audit-header'>
                <FormattedMessage
                    id='RECORD_AUDIT_FOR'
                    values={{dealer: buildAuditDealerString(props.leadAccountName, props.city, props.state)}}
                />
                <div className='button-group'>
                    <Link
                        className='secondary'
                        to={'/tcsm/audits'}
                    >
                        <FormattedMessage id='BACK'/>
                    </Link>

                    <div className='actions-button'>
                        <ActionsPopover
                            icon={'PDF'}
                            label={'PRINT'}
                            options={options}
                            showButtonIcon={true}
                        />
                    </div>

                    <button
                        className='primary'
                        onClick={props::handleSubmit}
                    >
                        <FormattedMessage id='SUBMIT_AUDIT'/>
                    </button>
                </div>
            </div>
        </div>

    );

};
RecordAuditHeader.displayName = 'RecordAuditHeader';

RecordAuditHeader.propTypes = {
    actions: PropTypes.object.isRequired,
    city: PropTypes.string.isRequired,
    claims: PropTypes.arrayOf(PropTypes.instanceOf(Claim)).isRequired,
    leadAccountName: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default RecordAuditHeader;



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/components/record-audit-header/record-audit-header.js